import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { showErrorAlert } from '../../../redux/Actions';
import { getAgentTicketsDetailedView } from '../../../redux/Report/ReportActions';
import { formatDecimal } from '../../../utils/helpers';
import ReportHeader from '../../../common/ReportHeader';
import { Box, Divider, Typography } from '@mui/material';
import ReportTableFilter from '../../../common/ReportTableFilter';
import { agentTicketColDef, agentTicketFilterCol, agentTicketRefundColDef, agentTicketRefundTotalColDef, agentTicketTotalColDef } from '../constants';
import dayjs from 'dayjs';
import { reportGenerationDateFormat } from '../../../common/constant';
import VirtualizedTable from '../../../common/VirtualizedTable';
import ExcelAndPrint from '../../../common/ExcelAndPrint';
import { decryptText } from '../../../utils/Decrypt';

const AgentTicket = () => {
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [paramsLoaded, setParamsLoaded] = useState(false);
    const [reportData, setReportData] = useState({})
    let decryptedData = {}
    try {
        const paramData = searchParams.get("data");
        if (paramData) {
            decryptedData = JSON.parse(decryptText(decodeURIComponent(paramData)));
        }
    } catch (error) {
        console.error("Invalid query data:", error);
    }

    const { userId, blnIsJDate, FromDate, ToDate, companyID, agentID, isCancel, operatorName = 'All Operators' } = decryptedData


    useEffect(() => {
        if (searchParams.toString()) {
            setParamsLoaded(true);
        }
    }, [searchParams]);
    useEffect(() => {
        if (!paramsLoaded) return;
        const requiredFields = [userId, FromDate, ToDate, companyID, agentID];

        const hasError = requiredFields.some(
            (val) => val === undefined || val === null
        );
        if (hasError) {
            dispatch(showErrorAlert('Invalid URL: Missing required parameters'));
            return;
        }
        const body = {
            intUserID: userId,
            blnIsJDate: blnIsJDate,
            dtFromDate: FromDate,
            dtToDate: ToDate,
            intCompanyID: companyID,
            intBranchID: 0,
            intAgentCityID: 0,
            intAgentID: agentID,
            intRouteCityID: 0,
            intTripID: 0,
            blnAddCancelations: isCancel
        }
        dispatch(getAgentTicketsDetailedView(body)).then((res) => {
            if (res.data.status) {
                let parseData = JSON.parse(res?.data?.Data || "{}") || {}
                const { agentTicketData = [], agentTicketRefundData = [] } = formatData(parseData)
                setReportData((prev) => ({
                    ...prev,
                    agentTicketData,
                    agentTicketRefundData
                }))
            } else {
                dispatch(showErrorAlert(res.data.Message))
            }
        })
    }, [
        paramsLoaded,
        userId,
        blnIsJDate,
        FromDate,
        ToDate,
        companyID,
        agentID,
        isCancel,
        dispatch,
    ])

    const formatData = (data = {}) => {
        let totalRow = {
            SeatCount: 0,
            amount: 0,
            BkgChargs: 0,
            discount: 0,
            GST: 0,
            net: 0
        }
        let agentTicketData = []
        agentTicketData = data.Table?.map((item, index) => {
            let netAmt = formatDecimal(Number(item.TotalFare) - Number(item.AgentComm) - Number(item.Discount))
            totalRow = {
                ...totalRow,
                SeatCount: formatDecimal(Number(totalRow.SeatCount) + Number(item.SeatCount)),
                amount: formatDecimal(Number(totalRow.amount) + Number(item.TotalFare)),
                BkgChargs: formatDecimal(Number(totalRow.BkgChargs) + Number(item.AgentComm)),
                discount: formatDecimal(Number(totalRow.discount) + Number(item.Discount)),
                GST: formatDecimal(Number(totalRow.GST) + Number(item.STax)),
                net: formatDecimal(Number(totalRow.net) + netAmt)

            }
            return {
                ...item,
                JourneyDate: dayjs(item.JourneyDate).format('DD-MMM-YYYY'),
                BusNumber: '',
                pnrTicket: `${item.BookingID} - ${item.TicketNo}`,
                SrNo: index + 1,
                amount: formatDecimal(item.TotalFare),
                BkgChargs: formatDecimal(item.AgentComm),
                discount: formatDecimal(item.Discount),
                GST: formatDecimal(item.STax),
                net: netAmt
            }
        })
        if (agentTicketData.length > 0) {
            agentTicketData.push({
                isTotalRow: true,
                align: "left",
                totalCaption: "Total",
                colSpan: 13,
                ...totalRow,
            })
        }

        let refundtotalRow = {
            SeatCount: 0,
            amount: 0,
            AgentComm: 0,
            discount: 0,
            GST: 0,
            net: 0,
            charge: 0
        }


        let agentTicketRefundData = []
        agentTicketRefundData = data.Table1?.map((item, index) => {
            let netAmt = 0
            let checkNetAmt = Number(item.RefundAmount) - Number(item.AgentComm) - Number(item.Discount)
            if (checkNetAmt > 0) {
                netAmt = formatDecimal(Number(item.RefundAmount) + Number(item.CCEarned) - Number(item.AgentComm) - Number(item.Discount));
            } else {
                netAmt = formatDecimal(Number(item.RefundAmount) + Number(item.AgentComm) - Number(item.Discount))
            }

            let charge = 0
            let checkCharge = (Number(item.RefundAmount) === 0)

            if (checkCharge) {
                charge = formatDecimal(Number(item.TotalFare) - Number(item.RefundAmount) - Number(item.AgentComm) - Number(item.CCEarned));
            } else {
                charge = formatDecimal(Number(item.TotalFare) - Number(item.RefundAmount) - Number(item.CCEarned));
            }
            refundtotalRow = {
                ...refundtotalRow,
                SeatCount: formatDecimal(Number(refundtotalRow.SeatCount) + Number(item.SeatCount)),
                amount: formatDecimal(Number(refundtotalRow.amount) + Number(item.TotalFare)),
                AgentComm: formatDecimal(Number(refundtotalRow.AgentComm) + Number(item.AgentComm)),
                BkgChargs: formatDecimal(Number(refundtotalRow.BkgChargs) + Number(item.AgentComm)),
                discount: formatDecimal(Number(refundtotalRow.discount) + Number(item.Discount)),
                charge: formatDecimal(Number(refundtotalRow.charge) + Number(charge)),
                GST: formatDecimal(Number(refundtotalRow.GST) + Number(item.STax)),
                net: formatDecimal(Number(refundtotalRow.net) + netAmt)
            }
            return {
                ...item,
                JourneyDate: dayjs(item.JourneyDate).format('DD-MMM-YYYY'),
                BusNumber: '',
                pnrTicket: `${item.BookingID} - ${item.TicketNo}`,
                SrNo: index + 1,
                amount: formatDecimal(item.TotalFare),
                discount: formatDecimal(item.Discount),
                GST: formatDecimal(item.STax),
                charge: charge,
                net: netAmt
            }
        })
        if (agentTicketRefundData.length > 0) {
            agentTicketRefundData.push({
                isTotalRow: true,
                align: "left",
                totalCaption: "Total",
                colSpan: 12,
                ...refundtotalRow,
            })
        }
        return {
            agentTicketData, agentTicketRefundData
        }
    }
    const filterData = {
        type: blnIsJDate ? 'Journey Date' : 'Transaction Date',
        journeyDate: `${dayjs(FromDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')} to ${dayjs(ToDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')}`,
        reportDate: dayjs(window.getTime ? window.getTime() : new Date()).format(reportGenerationDateFormat),
        operator: operatorName
    }
    return (
        <>
            <ReportHeader reportitle='Agent Ticket Report' />
            <Box sx={{ padding: '12px 16px 8px 16px' }}>
                <ReportTableFilter
                    columnDef={agentTicketFilterCol}
                    data={filterData}
                />
            </Box>
            <Box sx={{ padding: '8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                <Typography variant="h6" >
                    AGENT TICKET DETAILS
                </Typography>
                <ExcelAndPrint
                    reportTitle='Agent Ticket Report'
                    multiTable={[{
                        titleTable: ' AGENT TICKET DETAILS',
                        columnDef: agentTicketColDef,
                        body: reportData.agentTicketData,
                    },
                    {
                        titleTable: 'AGENT TICKET (REFUNDS)',
                        columnDef: agentTicketRefundColDef,
                        body: reportData.agentTicketRefundData,
                    },

                    ]}
                    filterSectionColumn={agentTicketFilterCol}
                    filterSectionData={filterData}

                />
            </Box>
            <Divider />
            <Box sx={{ overflowX: 'auto', margin: '0px 16px 16px 0px' }}>
                <Box sx={{ padding: '12px 16px' }}>
                    <VirtualizedTable
                        tableData={reportData.agentTicketData || []}
                        columnDefs={agentTicketColDef}
                        totalColumnDef={agentTicketTotalColDef}
                    />
                </Box>

                <Box sx={{ padding: '8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                    <Typography variant="h6" >
                        AGENT TICKET (REFUNDS)
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ padding: '12px 16px' }}>
                    <VirtualizedTable
                        tableData={reportData.agentTicketRefundData || []}
                        columnDefs={agentTicketRefundColDef}
                        totalColumnDef={agentTicketRefundTotalColDef}
                    />
                </Box>
            </Box>
        </>
    )
}

export default AgentTicket